// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/ui/qr-popup/styles.less
// module id = 1113
// module chunks = 10